// Portions Copyright 2019 Jimb Esser (https://github.com/Jimbly/)
// Released under MIT License: https://opensource.org/licenses/MIT

export let FRIEND_ADDED = 1;
export let FRIEND_ADDED_AUTO = 2;
export let FRIEND_REMOVED = 3;
export let FRIEND_BLOCKED = 4;

export let PRESENCE_OFFLINE = 0; // for invisible, etc
export let PRESENCE_ACTIVE = 1;
export let PRESENCE_INACTIVE = 2;

export const ID_PROVIDER_APPLE = 'apl';
export const ID_PROVIDER_FB_GAMING = 'fbg';
export const ID_PROVIDER_FB_INSTANT = 'fbi';
